import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Debounced live preview for the Configure panel's live result preview
// column (round 5, card #3613/#3634). Any input/change anywhere in the
// tracking settings form (bubbling -- no per-field wiring needed) re-POSTs
// the whole form as unsaved state to MissionTasksController
// #preview_tracking_settings, which renders an in-memory, never-persisted
// preview record and returns a turbo_stream.replace of the preview frame --
// applied via Turbo.renderStreamMessage rather than hand-built HTML, per
// CLAUDE.md. The initial preview is already server-rendered (tracking_settings
// .html.erb / _config_preview.html.erb), so this controller never fires on
// connect -- only on genuine user input.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.timer = null
    this.boundSchedulePreview = this.schedulePreview.bind(this)
    this.element.addEventListener("input", this.boundSchedulePreview)
    this.element.addEventListener("change", this.boundSchedulePreview)
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundSchedulePreview)
    this.element.removeEventListener("change", this.boundSchedulePreview)
    if (this.timer) clearTimeout(this.timer)
  }

  schedulePreview() {
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => this.fetchPreview(), 300)
  }

  async fetchPreview() {
    // The form's own action is a PATCH (tracking_settings_mission_task_path),
    // so form_with renders a hidden _method=patch field. Left in place, Rack::
    // MethodOverride would rewrite this fetch's real POST into a PATCH before
    // it reaches the router -- and the preview route only exists as POST.
    // Strip it so this always reaches #preview_tracking_settings as a POST.
    const formData = new FormData(this.element)
    formData.delete("_method")

    // Optional chaining, matching review_actions_controller.js's convention --
    // the meta tag is absent whenever forgery protection is disabled (e.g.
    // the test environment), not just in production.
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const response = await fetch(this.urlValue, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      }
    })

    if (!response.ok) return

    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }
}
